module.exports = __webpack_public_path__ + "static/media/Gicon.0b1e5c66.png";